/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DataModelMassActionType {
    RANGE_SET = 'range-set',
    SALARY_RANGE = 'salary-range',
    RANGE_ZONE = 'range-zone',
    RANGE_GROUP = 'range-group',
}
